module.exports = __webpack_public_path__ + "img/logo.f7a2a953.png";